import { useCallback, useMemo } from "react";
import {
  getAllBookingLabels,
  getAllCustomerLabels
} from "../../../../SelectedBooking/Labels/BookingLabels";

interface UseDiaryBookingCardColorPropsProps {
  venueConfig: any;
  venueGroupConfig: any;
}

export const useDiaryBookingCardColors = ({
  venueConfig,
  venueGroupConfig
}: UseDiaryBookingCardColorPropsProps) => {
  // Memoize label configs to avoid re-computation on every render
  const allAvailableBookingLabels = useMemo(
    () =>
      venueConfig && venueGroupConfig
        ? getAllBookingLabels({
            venueConfig,
            venueGroupConfig
          })
        : [],
    [venueConfig, venueGroupConfig]
  );

  const allAvailableCustomerLabels = useMemo(
    () =>
      venueConfig && venueGroupConfig
        ? getAllCustomerLabels({
            venueConfig,
            venueGroupConfig
          })
        : [],
    [venueConfig, venueGroupConfig]
  );

  const getBookingLabelColor = useCallback(
    (labelId: string): { backgroundColour: string; labelColour: string } => {
      const label = allAvailableBookingLabels.find(
        (l: any) => l.id === labelId
      );

      if (label?.colour) {
        const isLightTheme =
          document.documentElement.getAttribute("data-theme") === "Light";
        const baseColor = `#${label.colour}`;

        return {
          backgroundColour: baseColor,
          labelColour: isLightTheme ? "#000000" : "#ffffff"
        };
      }

      const isLightTheme =
        document.documentElement.getAttribute("data-theme") === "Light";

      return {
        backgroundColour: isLightTheme ? "#e5e7eb" : "#4b5563",
        labelColour: isLightTheme ? "#374151" : "#e5e7eb"
      };
    },
    [allAvailableBookingLabels]
  );

  const getCustomerLabelColor = useCallback(
    (labelId: string): { backgroundColour: string; labelColour: string } => {
      const label = allAvailableCustomerLabels.find(
        (l: any) => l.id === labelId
      );

      if (label?.colour) {
        const isLightTheme =
          document.documentElement.getAttribute("data-theme") === "Light";
        return {
          backgroundColour: `#${label.colour}`,
          labelColour: isLightTheme ? "#000000" : "#ffffff"
        };
      }

      const isLightTheme =
        document.documentElement.getAttribute("data-theme") === "Light";
      return {
        backgroundColour: isLightTheme ? "#e5e7eb" : "#4b5563",
        labelColour: isLightTheme ? "#374151" : "#e5e7eb"
      };
    },
    [allAvailableCustomerLabels]
  );

  return {
    allAvailableBookingLabels,
    allAvailableCustomerLabels,
    getBookingLabelColor,
    getCustomerLabelColor
  };
};
